module.exports = __webpack_public_path__ + "static/img/10.e6d798e6.png";